import React, { FC } from "react";

import { FourthStepInfoContainer } from "../FormElements";

import { interpolate } from "../Helpers";
import { useLabels } from "../Hooks/useLabels";

import { ServiceDto } from "@apiModels/ServiceDto.csharp";
import { SpecializationDto } from "../../../../Api/Model/SpecializationDto.csharp";
import { CreateBookingResponseDto } from "../../../../Api/Model/CreateBookingResponseDto.csharp";

type PracticalInformationProps = {
  bookingResponse: CreateBookingResponseDto;
  service: ServiceDto;
  specialization: SpecializationDto;
  isWaitlist: boolean;
  hideGeneralInfo?: boolean;
};

export const PracticalInformation: FC<PracticalInformationProps> = ({
  bookingResponse,
  service,
  specialization,
  isWaitlist,
  hideGeneralInfo,
}) => {
  const { bookingLabels } = useLabels();
  const fourthStepLabels = bookingLabels?.stepsBookingLabels.fourthStepLabels;
  const displayVideoLink =
    bookingResponse.videoLink &&
    bookingResponse.videoLink.url &&
    bookingResponse.videoLink.title;

  const link = fourthStepLabels!.serviceLink.replace(
    "$service",
    !!service.serviceUrl ? service.name : specialization.name
  );

  const shouldShow =
    (displayVideoLink && !!bookingResponse.videoDescription) ||
    !!bookingResponse.practicalInformationDoctor ||
    !!bookingResponse.practicalInformation ||
    (!isWaitlist && !hideGeneralInfo && !!fourthStepLabels?.generalInfo);

  if (!shouldShow) {
    return null;
  }
  return (
    <FourthStepInfoContainer>
      <h3>
        {fourthStepLabels?.practicalInformationHeading ??
          "Nødvendig informasjon"}
      </h3>
      {displayVideoLink && (
        <div
          dangerouslySetInnerHTML={{
            __html: interpolate(
              bookingResponse.videoDescription,
              "$videoLink",
              `<a href="${bookingResponse.videoLink.url}">
            ${bookingResponse.videoLink.title}
          </a>`
            ),
          }}
        />
      )}
      {bookingResponse.practicalInformationDoctor && (
        <div
          dangerouslySetInnerHTML={{
            __html: bookingResponse.practicalInformationDoctor,
          }}
        />
      )}
      {bookingResponse.practicalInformation && (
        <div
          dangerouslySetInnerHTML={{
            __html: bookingResponse.practicalInformation,
          }}
        />
      )}
      {!isWaitlist && !hideGeneralInfo && (
        <>
          <div
            dangerouslySetInnerHTML={{
              __html: fourthStepLabels?.generalInfo ?? "",
            }}
          />
          <p className="mb-1">
            <a href={service.serviceUrl || specialization.specializationUrl}>
              <span className="d-flex justify-content-start">
                <span className="fw-bold">{link}</span>
                <span className="square-cta__btn-arrow__small mx-1" />
              </span>
            </a>
          </p>
        </>
      )}
    </FourthStepInfoContainer>
  );
};
